import { options } from '@shared/shared.module';
import { Formio } from 'angular-formio';
import { interval } from 'rxjs';

const Base = (Formio as any).Components.components.component;
const Components = (Formio as any).Components;

export class CustomSelect extends Base {

  // Valores do formbuild do componente
  private component;
  // opções do form render
  private options;
  // objeto com o valor do componente
  private data;
  // verifica se o componente está no editor
  private editor;


  private input;
  private value;
  private optionsContainer: Element;
  private insideContainer = false;


  constructor(component, options, data) {
    super(component, options, data);
    this.component = component;
    this.options = options;
    this.data = data;
    this.editor = options.editor;
  }

  static schema() {
    return Base.schema({
      type: 'select',
    });
  }

  /**
   * Render returns an html string of the fully rendered component.
   *
   * @param children - If this class is extendended, the sub string is passed as children.
   * @returns {string}
   */
  render(children) {
    this.count++;
    let content = ''
    content += this.createSelectComponent();
    const template = super.render(`<div>${content}</div>`);
    return template;
  }

  createSelectComponent() {
    const label = this.component.label;
    const inputAttr: any = {
      id: `${this.component.key}-auto-complete-input`,
      class: 'ps-auto-complete-input form-control',
      type: 'text',
      autocomplete: "off",
      autocorrect: "off",
      autocapitalize: "none",
      spellcheck: "false"
    }

    if (this.component.disabled || this.component.isDisabled) {
      inputAttr.disabled = true;
    }

    if (this.component.placeholder) {
      inputAttr.placeholder = this.component.placeholder;
    }

    const input = this.renderTemplate('input', {
      input: {
        type: 'input',
        ref: `${this.component.key}-auto-complete-input`,
        class: 'ps-autocomplete-input',
        attr: inputAttr
      }
    })


    let select =
    `
    <div class="ps-auto-complete-input-container" name="${this.component.relation_id ?? ''}">
      <div class="ps-comp-select-container-column">
        ${this.createLabel('top', label)}
        <span class="ps-input-autocomplete-filter-clear">
          ${input}
          ${this.getItemRemoveOption()}
        </span>
        ${this.createLabel('bottom', label)}
      </div>
      <div class="form-text text-muted">${this.component.description}</div>
      <div ref="${this.component.key}-auto-complete-options" class="ps-comp-select-container-column ps-auto-complete-option-container-closed ps-auto-complete-option-container">
      </div>
    </div>
    `
    ;
    return select;
  }

  private getItemRemoveOption() {
    if (!this.component?.isDisabled) {
      return `<i 
        id="${this.component.key}-auto-complete-clear" 
        ref="${this.component.key}-auto-complete-clear" 
        class="material-icons ps-icon-hidden">
        clear
      </i>`
    }

    return '';
  }

  createLabel(position, label) {
    const labelElement = `<div class="ps-comp-select-container-row ps-custom-select-label">${label}  ${this.createTolltip()}</div>`;
    if (position === 'top' && this.component.labelPosition === 'top' && !this.component.hideLabel) {
      return labelElement;
    }

    if (position === 'bottom' && this.component.labelPosition === 'bottom' && !this.component.hideLabel) {
      return labelElement;
    }

    return '';
  }

  createTolltip() {
    if (this.component.tooltip) {
      return `<i class="material-icons text-muted ps-defalt-icon-size" ref="tooltip" aria-hidden="true" aria-describedby="${this.component.tooltip}">help</i>`
    } else {
      return '';
    }
  }


  getOptions(): Array<any> {
    if (this.component.data && this.component.data.values) {
      return  this.component.data.values;
    } else {
      return [];
    }
  }

  /**
   * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
   * elements to attach functionality to.
   *
   * @param element
   * @returns {Promise}
   */

  attach(element) {
    this.loadUploadElementRefs(element);
    let input = this.refs[`${this.component.key}-auto-complete-input`][0];
    let clear = this.refs[`${this.component.key}-auto-complete-clear`][0];
    let optionsContainer = this.refs[`${this.component.key}-auto-complete-options`][0];
    this.optionsContainer = optionsContainer;
    if (input && optionsContainer) {
      const touchOutsideOptionsHandler = (event)=>{
        var touch = event.touches[0]; 
        if (!optionsContainer.contains(touch.target) && !input.contains(touch.target)) {
          this.insideContainer = false;
          this.blurAutoComplete(input);
        }
      };
      this.createdOptionList(this.getOptions());
      this.addEventListener(input, 'keyup', (event) => this.filterValueChanged(true, event));
      this.addEventListener(input, 'keydown', (event) => this.enterSelection(event, input));
      this.addEventListener(input, 'focus', () => {
        document.addEventListener('touchstart', touchOutsideOptionsHandler);
        this.focusAutoComplete();
      });
      this.addEventListener(input, 'blur', () => {
        document.removeEventListener('touchstart', touchOutsideOptionsHandler);
        this.blurAutoComplete(input)
      });
      this.addEventListener(optionsContainer, 'mouseover', () => { this.insideContainer = true; });
      this.addEventListener(optionsContainer, 'mouseout', () => { this.insideContainer = false });
      this.addEventListener(clear, 'click', () => { this.verifyAndClearInputValue(); });

      if (Array.isArray(this.value) && this.value.length > 0) {
        this.setInputObject(input, this.value);
        this.setValue(this.value);
      } else if (!Array.isArray(this.value) && this.value && this.value !== '') {
        this.setInputObject(input, this.value);
        this.setValue(this.value);
      } else {
        this.setInputObject(input, null);
      }

    }
    return super.attach(element);
  }

  setInputObject(input, value) {
    if (this.component.multivalued) {
      this.input = {filter: input, value: value ?? []};
    } else {
      this.input = {filter: input, value: value ?? ''};
    }
  }

  enterSelection(event, input) {
    if (event.key === 'Enter') {
      const options = this.filterOptions();
      if (!this.component.multivalued) {
        if (options[0]) {
          this.input.value = String(options[0].value);
          this.filterValueChanged(false)
          this.input.filter.blur();
        } 
      }
    }
  }

  focusAutoComplete() {
    this.openOptionsContainer();
    this.filterValueChanged(false);
  }

  openOptionsContainer() {
    this.optionsContainer.classList.remove('ps-auto-complete-option-container-closed');
  }


  blurAutoComplete(input) {
    if (this.insideContainer === false) {
      if (!this.component.multivalued) {
        input.placeholder = this.getLabelsForPlaceholder();
        input.title = this.getLabelsForPlaceholder();
        this.update();
        this.closeOptionsContainer();
        this.input.filter.value = '';
      } else {
        input.placeholder = this.getLabelsForPlaceholder();
        input.title = this.getLabelsForPlaceholder();
        this.update();
        this.closeOptionsContainer();
        this.input.filter.value = '';
      }
    }      
  }

  update() {
    const clear = document.getElementById(`${this.component.key}-auto-complete-clear`);
    if(this.input) {
      this.updateValue();
    }
    if (this.input && clear) {
      if (Array.isArray(this.input.value)) {
        if (this.input.value.length > 0) {
          clear.classList.remove("ps-icon-hidden");
        } else {
          clear.classList.add("ps-icon-hidden");
        }
      } else {
        if(this.input.value != '') {
          clear.classList.remove("ps-icon-hidden");
        } else {
          clear.classList.add("ps-icon-hidden");
        }
      }
    }
  }

  getLabelsForPlaceholder() { 
    let placeholder = ''
    const options = this.getOptions();
    options.forEach((option, index) => {
      if (Array.isArray(this.input.value)) {
        this.input.value.forEach(value => {
          if (value == option.value) {
            if (placeholder == '') {
              placeholder = option.label;
            } else {
              placeholder += ', ' + option.label;
            }
          } 
        });
      } else {
        if (option.value == this.input.value) {
          placeholder = option.label;
        }
      }
    });
    return placeholder;
  };

  closeOptionsContainer() {
    this.optionsContainer.classList.add('ps-auto-complete-option-container-closed');
  }

  filterValueChanged(clear, event?) {
    if (clear && (event && event.key !== 'Tab' && event.key !== 'Enter')) {
      const options = this.filterOptions();
      this.createdOptionList(options);
    } else {
      const options = this.filterOptions();
      this.createdOptionList(options);
    }
    if ((event && event.key !== 'Tab' && event.key !== 'Enter')) {
      this.openOptionsContainer();
    }
  }

  createdOptionList(options: Array<any>) {
    this.optionsContainer.innerHTML = '';
    if (options.length > 0) {
      let currentPath = "";
      let numberOfCategories = 0;

      if(this.component.multivalued) {
        options.map((option) => {
          if (option.path && currentPath !== option.path) {
            currentPath = option.path;
            numberOfCategories++;
            this.optionsContainer.appendChild(this.createOptionCategory(option));
          }
          this.optionsContainer.appendChild(this.createOptionWithCheckbox(option));
        });
      } else {
        options.map((option)=> {
          if (option.path && currentPath !== option.path) {
            currentPath = option.path;
            numberOfCategories++;
            this.optionsContainer.appendChild(this.createOptionCategory(option));
          }
          const optionElement = document.createElement('span');
          optionElement.innerText = option.label;
          optionElement.setAttribute('class', 'ps-auto-complete-option-item');
          this.addEventListener(optionElement, 'click', () => this.clickedOption(option));
          this.optionsContainer.appendChild(optionElement);
        });
      }
      if (numberOfCategories < 2) {
        this.optionsContainer.classList.add('ps-auto-complete-option-category-hidden');
      } else {
        this.optionsContainer.classList.remove('ps-auto-complete-option-category-hidden');
      }
    } else {
      const optionElement = document.createElement('span');
      optionElement.innerText = 'Sem resultados encontrados';
      optionElement.setAttribute('class', 'ps-auto-complete-no-option-item');
      this.addEventListener(optionElement, 'click', () => this.closeOptionsContainer());
      this.optionsContainer.appendChild(optionElement);
    }
  }

  createOptionCategory(option) {
    const categoryElement = document.createElement('span');
    categoryElement.setAttribute('class', 'ps-auto-complete-option-category');
    if (option.multiplePaths) {
      categoryElement.setAttribute('title', 'Múltiplas opções selecionadas nos campos anteriores: ' + option.path);
    } else {
      categoryElement.setAttribute('title', 'Opções selecionadas nos campos anteriores: ' + option.path);
    }
    categoryElement.innerText = option.path;
    this.addEventListener(categoryElement, 'click', () => this.input.filter.focus());
    return categoryElement;
  };

  createOptionWithCheckbox(option) {
    const optionElement = document.createElement('div');
    const optionText = document.createElement('span');
    const checkboxElement = document.createElement('input');
    checkboxElement.setAttribute('class', 'form-check-input-select');
    checkboxElement.setAttribute('type', 'checkbox');
    this.setCheckBoxValue(checkboxElement, option);
    optionText.innerText = option.label;
    optionElement.appendChild(checkboxElement);
    optionElement.appendChild(optionText);
    optionElement.setAttribute('class', 'ps-auto-complete-option-item-multiple');
    this.addEventListener(optionElement, 'click', () => this.clickedOptionCheckbox(option));
    return optionElement;
  }

  checkValueToAppend(values: Array<any>, option) {
    if (Array.isArray(values)) {
      if (!values.includes(option.value)) {
        return true;
      } else {
        return false
      }
    }
  }

  clickedOptionCheckbox(option) {
    if (Array.isArray(this.input.value)) {
      const canAppend = this.checkValueToAppend(this.input.value, option);
      if (canAppend) {
        if (
          !this.component.max_multivalued_options ||
          this.input.value.length < this.component.max_multivalued_options ||
          this.component.max_multivalued_options == 0
          ) {
            this.input.value.push(option.value);
          } 
      } else {
        let indexToRemove = -1;
        this.input.value.forEach((value, index) => {
          if (value == option.value) {
            indexToRemove = index;
          }
        });
        this.input.value.splice(indexToRemove, 1);
      }
    }
    this.input.filter.placeholder = this.getLabelsForPlaceholder();
    this.input.filter.title = this.getLabelsForPlaceholder();
    this.input.filter.focus();
  }


  clickedOption(option) {
    this.insideContainer = false;
    this.input.value = String(option.value);
    this.update();
    this.closeOptionsContainer();
    this.input.filter.blur();
    this.input.filter.value = '';
    this.input.filter.placeholder = this.getLabelsForPlaceholder();
    this.input.filter.title = this.getLabelsForPlaceholder();
  }

  setCheckBoxValue(element, option) {
    if (this.input && Array.isArray(this.input.value)) {
      this.input.value.forEach(value => {
        if (value === option.value) {
          element.setAttribute('checked', true);
        }
      });
    }
  }

  filterOptions () {
    const value: string = this.input.filter.value;
    let options = this.getOptions();
    if (value != '') {
      const filterValue = value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      options = options.filter((option) =>
        option.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(filterValue)).sort((a, b) => {
          if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          } else if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          } else {
            return 0;
          }
        });
        const group = options.reduce((result, currentValue) => {
          (result[currentValue['path']] = result[currentValue['path']] || []).push(
            currentValue
          );
          return result;
        }, {});
        options = [];
        for (const key in group) {
          if (Object.prototype.hasOwnProperty.call(group, key)) {
            const optionsGroup = group[key];
              optionsGroup.map(option => {
                options.push(option);
              });
          }
        }
        return options
    } else {
      const group = options.reduce((result, currentValue) => {
        (result[currentValue['path']] = result[currentValue['path']] || []).push(
          currentValue
        );
        return result;
      }, {});
      options = [];
      for (const key in group) {
        if (Object.prototype.hasOwnProperty.call(group, key)) {
          const optionsGroup = group[key];
            optionsGroup.map(option => {
              options.push(option);
            });
        }
      }
      return options;
    }
  }

  verifyAndClearInputValue(){
    if (!this.component.multivalued) {
      this.input.value = '';
    } else {
      this.input.value = [];
    }
    this.input.filter.placeholder = this.getLabelsForPlaceholder();
    this.input.filter.title = this.getLabelsForPlaceholder();
    this.component.properties.cleaning = true;
    this.update();
  }


  /**
   * carrega as referencias especificas do elemento upload no array global de referencias do DOM
   * @param index
   */

  loadUploadElementRefs(element) {
    const refs = [];
    refs[`${this.component.key}-auto-complete-input`] = 'multiple';
    refs[`${this.component.key}-auto-complete-options`] = 'multiple';
    refs[`${this.component.key}-auto-complete-clear`] = 'multiple';
    refs[`${this.component.key}-auto-complete-loader`] = 'multiple';
    this.loadRefs(element, refs);
  }



  /**
  * Get the value of the component from the dom elements.
  *
  * @returns {Array}
  */

   getValue() {
     if (this.input && this.input.value !== null) {
        this.value = this.input.value;
        let value = this.input.value;
        if (Array.isArray(value)) {
          return JSON.parse(JSON.stringify(value));
        }
        return value;
      } else if (this.component.multivalued) {
        return [];
      } else {
       return '';
     }
  }

  /**
   * Set the value of the component into the dom elements.
   * @param value
   * @returns {Array}
   */
  public setValue(value) {
    if (value && value != '') {
      const foundOption = this.filterValue(value);
      if (!Array.isArray(foundOption)) {
        if(foundOption) {
          const value = String(foundOption.value)
          if (this.component.multivalued) {
            this.value = [];
            this.value.push(value);
            if (this.input) {
              this.input.value = [];
              this.input.value.push(value);
            }
          } else {
            this.value = value;
            if (this.input) {
              this.input.value = value;
            }
          }
          if (this.input && this.input.filter) {
            this.input.filter.placeholder = this.getLabelsForPlaceholder();
            this.input.filter.title = this.getLabelsForPlaceholder();
            this.filterValueChanged(false);
          }
        }
      } else if (foundOption.length > 0) {
        if (this.input) {
          this.input.value = [];
        }
        this.value = [];
        foundOption.forEach((option) => {
          const value = String(option.value)
          this.value.push(value);
          if (this.input) {
            this.input.value.push(value);
          }
        });
        if (this.input && this.input.filter) {
          this.input.filter.placeholder = this.getLabelsForPlaceholder();
          this.input.filter.title = this.getLabelsForPlaceholder();
          this.filterValueChanged(false);
        }
      }
    this.update();
    }
  }

  filterValue (value: any): any {
    const options = this.getOptions();
    let foundWithKey = [];
    let foundWithLabel = [];
    if (!Array.isArray(value)) {
      if (value != '') {
        const filterValue = value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        foundWithKey = options.find((option) =>  option.value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') == filterValue) ?? false;
        foundWithLabel = options.find((option) =>  option.label.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') == filterValue) ?? false;
      }
      if (foundWithKey) {
        return foundWithKey;
      } else {
        if (foundWithLabel) {
          return foundWithLabel;
        }
      }
    } else if (value.length > 0) {
      value.forEach((val) => {
        const filterValue = val.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const filteredOptions = options.find((option) =>  option.value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') == filterValue) ?? false; 
        const filteredOptionsLabel = options.find((option) =>  option.label.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') == filterValue) ?? false;
        if (filteredOptions) {
          foundWithKey.push(filteredOptions);
        }
        if (filteredOptionsLabel) {
          foundWithLabel.push(filteredOptionsLabel);
        }
      });
      if (foundWithKey) {
        return foundWithKey;
      } else {
        if (foundWithLabel) {
          return foundWithLabel;
        }
      }

    }
    return false;
  }

}



export function registryCustoSelectFieldTypeComponent() {
  Components.addComponent('select', CustomSelect);
}



